/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/alt-text */
import { t } from 'i18next';
import React, { useRef } from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import useOutsideClick from 'shared/hooks/useOutsideClick';
import { HamburgerIcon, PollIcon, SettingsIcon, TimesIcon } from '../Icons';
import { getLocalizedPath } from 'utils/languageHelpers';

const MobileNavMenu = () => {
  const [open, setOpen] = useState(false);
  const dropdown = useRef();

  const toggleDropdown = () => setOpen(!open);
  useOutsideClick([dropdown], () => setOpen(false));

  return (
    <div className={`mobile-drop-menu d-flex align-items-center ${open ? 'active' : ''}`}>
      <div className='drop-toggle cursor-pointer' onClick={toggleDropdown} role='presentation'>
        {open ? <TimesIcon width='24' height='24' /> : <HamburgerIcon />}
      </div>
      <div className='drop-content' ref={dropdown}>
        <div className='d-flex align-items-center justify-content-around pt-7 pb-5'>
          <Link
            to={getLocalizedPath('/profile')}
            className='d-flex col-6 justify-content-center border-right align-items-center text-body fw-500'
            onClick={setOpen.bind(null, false)}
          >
            <SettingsIcon className='mr-3' />
            {t('text_settings')}
          </Link>
          <Link
            to={getLocalizedPath('/polls')}
            className='d-flex col-6 justify-content-center align-items-center text-body fw-500'
            onClick={setOpen.bind(null, false)}
          >
            <PollIcon className='mr-3' />
            {t('nav_poll')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default MobileNavMenu;
